<!--  -->
<template>
  <div class="all_box">
    <div>
      <el-form ref="ruleForm" :model="parameter" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="活动名称" prop="title">
          <el-input v-model="parameter.title" v-model.trim="parameter.title" style="width:300px" @input="parameter.title = parameter.title.replace(reg, '')" />
        </el-form-item>
        <el-form-item label="期限选择">
          <el-select v-model="time_type" placeholder="请选择">
            <el-option
              v-for="item in timeoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="time_type === 2" label="固定天数" prop="appoint_day">
          <el-input v-model="parameter.appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="parameter.appoint_day = parameter.appoint_day.replace(/[^A-z0-9]/, '')" />
        </el-form-item>
        <el-form-item v-if="time_type === 1" label="活动时间" prop="date">
          <el-date-picker
            v-model="parameter.date"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:410px"
            :clearable="false"
            :picker-options="pickerOptions"
            @change="datavalue"
          />

        </el-form-item>
        <el-form-item label="赠送书币" prop="gift_amount">
          <el-input v-model="parameter.gift_amount" style="width:300px" placeholder="赠送书币范围（1-200）" type="number" @blur="sendchagerracher" /> / 个
        </el-form-item>
        <el-form-item label="赠送总次数" prop="max_times">
          <el-select v-model="parameter.max_times" placeholder="请选择">
            <el-option
              v-for="item in [{value: '1次', id: 1}, {value: '2次', id: 2},{value: '3次', id: 3}]"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="频率限制" prop="activity_frequencies_enum">
          <el-select v-model="parameter.activity_frequencies_enum" placeholder="请选择">
            <el-option
              v-for="item in [{value: '每天一次', id: 2}, {value: '每周一次', id: 3}]"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <img class="feng_box" src="https://lf-cdn-tos.bytescm.com/obj/static/novel-fe/platform-cn/image/h5-gift-coin.3e39f951.png" alt="">
    </div>
  </div>
</template>

<script>
import { readingservice } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.date[0] == this.parameter.date[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        title: [
          { required: true, message: '请输入活动标题', trigger: 'blur' }
        ],
        recharge_amount: [
          { required: true, message: '请输入活动价格', trigger: 'blur' }
        ],
        gift_amount: [
          { required: true, message: '请输入赠送书币', trigger: 'blur' }
        ],
        max_times: [
          { required: true, message: '请选择赠送总次数', trigger: 'change' }
        ],
        activity_frequencies_enum: [
          { required: true, message: '请选择频率限制', trigger: 'change' }
        ],
        date: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ]
      },

      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      parameter: {
        stime: null, // 开始时间
        etime: null, // 结束时间
        title: null, // 标题
        recharge_amount: '', // 充值金额
        max_times: 1, // 会员时长
        date: [],
        gift_amount: null, // 赠送金额
        activity_frequencies_enum: null, // 频率限制
        appoint_day: ''
      },
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2
    }
  },
  created() {

  },
  mounted() {

  },

  methods: {
    datavalue(val) {
      console.log('val', val)
      this.parameter.stime = val[0]
      this.parameter.etime = val[1]
    },

    submitForm(formName) {
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.parameter.stime
            par.end_time = this.parameter.etime
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.parameter.appoint_day)
          }
          try {
            await readingservice({
              platform_id: this.platformid,
              activity_type: 4,
              ...par,
              activity_info: {
                name: this.parameter.title,
                // start_ts: this.parameter.stime,
                // end_ts: this.parameter.etime,
                gift_amount: Number(this.parameter.gift_amount),
                max_times: this.parameter.max_times,
                custom_activity_type: 3,
                activity_id: null,
                introduction: '',
                activity_price: 0,
                original_price: 0,
                activity_frequencies: {
                  activity_frequencies_enum: this.parameter.activity_frequencies_enum
                }
              }
            })
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$emit('close')
          } catch (err) {
            this.$message({
              message: err,
              type: 'warning'
            })
          }
        } else {
          false
        }
      })
    },
    chagerracher() {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.recharge_amount <= 0 && this.parameter.recharge_amount != '') {
        this.parameter.recharge_amount = 1
      }
    },
    sendchagerracher() {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.gift_amount <= 0 && this.parameter.gift_amount != '') {
        this.parameter.gift_amount = 1
      }
      if (this.parameter.gift_amount > 200) {
        this.parameter.gift_amount = 200
      }
    }

  }
}
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
/deep/ .el-input__inner::-webkit-outer-spin-button,
 /deep/ .el-input__inner::-webkit-inner-spin-button {
-webkit-appearance: none;
 }
/deep/ .el-input__inner[type='number'] {
-moz-appearance: textfield;
 }
.feng_box{
  width: 254px;
  height: 502px;
  margin-left: 100px;
}
.all_box{
  display: flex;
}
@media (max-width: 768px){
  .all_box[data-v-75a0cbde] {
    flex-direction: column;
    align-items: center;
  }
  .feng_box{
    margin:0;
  }
}
</style>

